// extracted by mini-css-extract-plugin
export default {"wrap":"Jlzahe79KkKAZG980B5G","table":"Zqthd3JwBNxpbmJL7rkd","head":"QDR9ZBM_4ExW1LKw_8qo"};